module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Increase-Energy.7a13ccfb.jpg";